// Simple fallback Analytics view that definitely renders
import React from 'react';

export const SimpleAnalyticsView: React.FC = () => {
  return (
    <div style={{ 
      padding: '2rem', 
      minHeight: '100vh',
      backgroundColor: '#000000',
      color: '#ffffff'
    }}>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '1.5rem', color: '#ffffff' }}>
        Analytics
      </h2>
      
      <div style={{ 
        padding: '1.5rem',
        borderRadius: '1rem',
        backgroundColor: 'rgba(28, 28, 30, 0.8)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
      }}>
        <p style={{ color: '#9ca3af', marginBottom: '1rem' }}>
          Analytics view is loading...
        </p>
        <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
          If you see this, the component is rendering. Check browser console for errors.
        </p>
      </div>
    </div>
  );
};

